module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.providers), function(item, index) {
    return _c('v-flex', {
      key: item.Code,
      attrs: {
        "xs12": "",
        "md2": ""
      }
    }, [_c('profile-provider-card', {
      attrs: {
        "provider": item
      },
      on: {
        "select": function($event) {
          _vm.detail(item.Code)
        }
      }
    })], 1)
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38be2bb7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ProfileProviders.vue
// module id = 392
// module chunks = 0